export default __webpack_public_path__ + "f93eab4c3ed6061581749bc8c321dcd9.png";